import React from "react"
import classnames from "classnames"
import {
  ButtonIcon,
  ArrowRightThinIcon,
  ArrowLeftThinIcon
} from "AtomicComponents"
import { HeroContent } from "AtomicContainers"
import { WINDOW } from "constants/environment"
import componentParser from "AtomicUtils/componentParser"
import styles from "./CardYoutubePlayerList.less"
import debounce from 'AtomicUtils/debounce'
class CardYoutubePlayerList extends React.Component {
  constructor(props){
    super(props)
    const { numberOfColumns = 3 } = props

    let widthOfCard = 350
    if (numberOfColumns === 3) widthOfCard = 350
    if (numberOfColumns === 4) widthOfCard = 280

    this.state = {
      widthOfCard: widthOfCard,
      arrowLeft: false,
      arrowRight: false,
      centerScrolling: false
    }
  }

  componentDidMount(){
    // check for arrows
    const { scrolling, showArrows = true } = this.props
    if ( scrolling && showArrows ) {
      this._checkForArrow({reset:false})
      WINDOW.addEventListener("resize", debounce(this._checkForArrow, 250))
    }
  }

  componentWillUnmount() {
    WINDOW.removeEventListener("resize", debounce(this._checkForArrow,250));
  }

  _checkForArrow = ({reset = true}) => {
    setTimeout(() => {
      if (this.list && this.listParent){
        const { widthOfCard } = this.state
        const maxMarginLeftPossible = this.list.scrollWidth - this.listParent.offsetWidth
        const currentMarginLeft = Number(this.list.style.marginLeft.replace('px','')) * -1
        let unitSize = widthOfCard + 16
        if (this.list.scrollWidth <= this.listParent.offsetWidth){
          this.setState({
            arrowLeft: false,
            arrowRight:false,
            centerScrolling:true
          })
        }else {
          this.setState({
            arrowLeft: currentMarginLeft > 0,
            arrowRight: currentMarginLeft < maxMarginLeftPossible,
            centerScrolling: false
          })
        }
        if (reset)
          this.list.style.marginLeft = `0px`
      }
    }, 10)
  }

  _handleRightClick = () => {
    const { widthOfCard } = this.state
    let unitSize = widthOfCard + 16
    const maxMarginLeftPossible = this.list.scrollWidth - this.listParent.offsetWidth
    const currentMarginLeft = Number(this.list.style.marginLeft.replace('px','')) * -1

    if (currentMarginLeft <= maxMarginLeftPossible - unitSize) {
      this.list.style.marginLeft = `-${currentMarginLeft+unitSize}px`
    }else {
      this.list.style.marginLeft = `-${maxMarginLeftPossible}px`
    }
    this._checkForArrow({reset:false})
  }

  _handleLeftClick = () => {
    const { widthOfCard } = this.state
    let unitSize = widthOfCard + 16
    const currentMarginLeft = Number(this.list.style.marginLeft.replace('px','')) * -1

    if (currentMarginLeft > unitSize) {
      this.list.style.marginLeft = `-${currentMarginLeft-unitSize}px`
    }else {
      this.list.style.marginLeft = `0px`
    }
    this._checkForArrow({reset:false})
  }

  render() {
    const {
      components = [],
      heading,
      description,
      imageSrc,
      showCounting=true,
      showArrows=true,
      scrolling=false,
      numberOfColumns = 3,
      children=[],
      gtm
    } = this.props

    const {
      widthOfCard,
      arrowLeft,
      arrowRight,
      centerScrolling
    } = this.state

    let length = (components && components.length > 0 && components.length) || children.length

    return (
      <div
        className={classnames({
          [styles.CardYoutubePlayerList]: true
        })}>
        { (heading ||
          description ||
          imageSrc ||
          showCounting) &&
          <HeroContent
            heading={heading}
            description={description}
            imageSrc={imageSrc}
            details={showCounting && `Showing ${length} items`} />
        }
        <div
          ref={c => this.listParent = c}
          className={classnames({
            [styles.CardYoutubePlayerListRoot]: true
          })}>
          <div
          ref={c => this.list = c}
          className={classnames({
            [styles.CardYoutubePlayerListView]: true,
            [styles.CardYoutubePlayerListViewScrolling]: scrolling,
            [styles.CardYoutubePlayerListViewCenterScrolling]: centerScrolling
          })}>
            {
              components &&
              components.length > 0 &&
              componentParser(components, {gtm: gtm}, undefined, false).map((item, index) => (
                <div
                  key={`CardYoutubePlayer-${index}`}
                  className={classnames({
                    [styles.CardYoutubePlayerListViewItem]: true,
                    [styles.CardYoutubePlayerListViewItemFour]: numberOfColumns === 4,
                    [styles.CardYoutubePlayerListViewItemFeatured]: item.props.featured
                  })}>
                  {item}
                </div>
              ))
            }
            {
              children &&
              children.length > 0 &&
              children.map((item, index) => (
                <div
                  key={`CardYoutubePlayer-${index}`}
                  className={classnames({
                    [styles.CardYoutubePlayerListViewItem]: true,
                    [styles.CardYoutubePlayerListViewItemFour]: numberOfColumns === 4,
                    [styles.CardYoutubePlayerListViewItemFeatured]: item.props.featured
                  })}>
                  {item}
                </div>
              ))
            }
          </div>
          {scrolling && showArrows && arrowRight &&
            <div  className={classnames({
              [styles.Arrow]: true,
              [styles.ArrowRight]: true
            })}>
              <ButtonIcon
                onClick={this._handleRightClick}
              >
                <ArrowRightThinIcon />
              </ButtonIcon>
            </div>
          }
          {scrolling && showArrows && arrowLeft &&
            <div  className={classnames({
              [styles.Arrow]: true,
              [styles.ArrowLeft]: true
            })}>
              <ButtonIcon
                onClick={this._handleLeftClick}
              >
                <ArrowLeftThinIcon />
              </ButtonIcon>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default CardYoutubePlayerList



// WEBPACK FOOTER //
// ./src/AtomicContainers/CardYoutubePlayerList/CardYoutubePlayerList.jsx